import { Component, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { BreederInfoReward } from 'src/app/classes/breeder-info-reward';
import { BreederInfo } from 'src/app/classes/breeder';
import { ClaimRewardPostModel } from 'src/app/classes/claim-reward-post-model';
import { BreederService } from 'src/app/services/breeder.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-claim-popup',
  templateUrl: './claim-popup.component.html',
  styleUrls: ['./claim-popup.component.scss']
})
export class ClaimPopupComponent {
  @ViewChild('claimForm', {static: false}) private _claimForm: NgForm;
  @Input() toClaimReward: BreederInfoReward;
  @Input() breederData: BreederInfo;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() rewardClaimed: EventEmitter<any> = new EventEmitter();

  public claimPostModel = new ClaimRewardPostModel();
  public succeed = false;

  constructor(private _breederService: BreederService) { }

  public triggerClose(): void {
    this._resetForm();
    this.succeed = false;
    this.close.emit(null);
  }

  public claimReward(): void {
    this.claimPostModel.rewardId = this.toClaimReward.rewardId;
    this._breederService.claimReward(this.claimPostModel).subscribe(res => {
      this.rewardClaimed.emit(true);
      this.succeed = true;
      this._resetForm();
    });
  }

  private _resetForm(): void {
    this.claimPostModel = new ClaimRewardPostModel();
    this._claimForm.resetForm();
  }
}
